import axios from "axios";
import { config_headers, servicelist, URL_API } from "../Config";

export const pContractorReport1_Info = async (body) => {
    return new Promise(async (resolve, reject) => {
        try {
            let authorization = await config_headers();
            await axios.post(URL_API(`${servicelist.contractorService}p_contractor_report_1_info`), body, authorization).then((res) => {
                resolve(res.data);
            });
        } catch (err) {
            reject(err);
        } finally {
        }
    });
};

export const pContractorReport1_Update = async (body) => {
    return new Promise(async (resolve, reject) => {
        try {
            let authorization = await config_headers();
            await axios.post(URL_API(`${servicelist.contractorService}p_contractor_report_1_update`), body, authorization).then((res) => {
                resolve(res);
            });
        } catch (err) {
            reject(err);
        } finally {
        }
    });
};
